export type ModifySegmentInstruction = server.dto.ModifyTrainSegmentInstruction & {
  startStation: server.dto.TrainStation
  endStation: server.dto.TrainStation
};

let key = 0;
export const defaultSegment = (): ModifySegmentInstruction & { key: number } => ({
  startLocal: new Date(),
  endLocal: new Date(),
  startStation: undefined,
  startStationId: undefined,
  endStation: undefined,
  endStationId: undefined,
  startPlatform: "",
  endPlatform: "",
  trainNumber: "",
  carriage: "",
  seats: "",
  travelClass: serverReference.trainTravelClasses.find(c => c.value === "unknown").value,
  key: ++key
});

export const defaultTrain = (): server.dto.ModifyTrainDetailsInstruction => ({
  phase: "confirmed",
  artistId: undefined,
  travellerIds: [],
  notes: "",
  bookingCode: "",
  travelAgency: ""
});

export const segmentToInstruction = (segment: server.dto.TrainSegment): ModifySegmentInstruction => ({
  startLocal: segment.start?.dateTimeLocal,
  endLocal: segment.end?.dateTimeLocal,
  startStation: segment.start?.station,
  startStationId: segment.start?.station?.id,
  endStation: segment.end?.station,
  endStationId: segment.end?.station?.id,
  startPlatform: segment.start?.platform,
  endPlatform: segment.end?.platform || "",
  trainNumber: segment.trainNumber || "",
  carriage: segment.carriage || "",
  seats: segment.seats || "",
  travelClass: segment.travelClass.value
});

export const trainDetailsToInstruction = (train: server.dto.Train): server.dto.ModifyTrainDetailsInstruction => ({
  phase: train.phase,
  artistId: train.artist?.artistId,
  travellerIds: train.travellers.map(t => t.contactId),
  notes: train.notes || "",
  bookingCode: train.bookingCode || "",
  travelAgency: train.travelAgency || ""
});

export const trainSegmentNewCopy = (startDate: Date, startStation: server.dto.TrainStation): server.dto.TrainSegment => ({
  id: 0,
  title: "",
  description: "",
  start: {
    dateTimeLocal: startDate || new Date(),
    station: startStation,
    platform: ""
  },
  distance: null,
  duration: null,
  end: {
    dateTimeLocal: startDate || new Date(),
    station: null,
    platform: ""
  },
  trainNumber: "",
  carriage: "",
  seats: "",
  travelClass: serverReference.trainTravelClasses.find(c => c.value === "unknown"),
  linkedShows: []
});

export const emptyTrain: () => server.dto.Train = () => ({
  id: 0,
  phase: "confirmed",
  bookingCode: "",
  travelAgency: "",
  notes: "",
  segments: [],
  artist: undefined,
  travellers: [],
  files: [],
  permissions: {
    canModify: true,
    canDelete: true
  }
});